import { Component, OnInit,ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder,FormControl, Validators, FormArray } from '@angular/forms';
import { Quotation } from 'app/shared/types/quotation';
import { ActivatedRoute,Router} from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'app/shared/services/dialog.service';
import { QuotationService } from 'app/shared/services/quotation.service';
import { ItemService } from 'app/shared/services/item.service';
import { CustomerService} from 'app/shared/services/customer.service';
import { AuthService } from 'app/shared/services/auth.service';
import { map, startWith, isEmpty} from 'rxjs/operators';
import { Observable} from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CanvasImageService} from 'app/shared/services/canvas-image.service';
import { CompanyProfileService } from 'app/shared/services/company-profile.service';
import { FileUploadService } from 'app/shared/services/file-upload.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { FileUploadComponent } from '../../../file-upload/file-upload.component';
import { DecimalPipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { NbThemeService } from '@nebular/theme';
import { LocationService } from 'app/shared/services/location.service';
import { ContainerTypeService } from 'app/shared/services/container-type.service';
import { LocationComponent } from '../../../master-files/location/location.component';
import { ContainerTypeComponent } from '../../../master-files/container-type/container-type.component';


@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.css']
})
export class QuotationComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>
  defaultDate : Date = new Date();
  isDark: boolean = false;
  checkData :any;
  itemList : any[]=[];
  filteredOptions:  Observable<any[]>[] = [];

  filteredCustomerList: Observable<any[]>;
  customerList : any[];

  containerTypeList:any;
  locationList:any;

  quotation: Quotation;
  quotationData = [];
  quotationForm: FormGroup;
  isfieldReadOnly : boolean= true;
  isHideBtn: boolean= false;
  isShowAttachBtn: boolean=false;
  isBtnDisabled : boolean= false;
  isCancelBtnDisabled : boolean= false;
  isCreateInvoiceBtnDisabled : boolean= true;
  isValidFormData: boolean = true;
  showProcessingIndicator =false;
  companyData : any  = [];
  logo :any;

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
 

  validationMessages = {
    'quotationNo': { 'required': 'Quotation number is required' },
    'quotationDate': { 'required': 'Quotation  date is required' },
    'cusName': {'required': 'Customer is required' },
    'address': {'required': 'Address is required' },
  };

  formErrors = {
    'quotationNo': "",
    'quotationDate': "",
    'cusName': "",
    'address': "",
  };

  DFT =[
    {value: '8 Hrs'},
    {value: '12 Hrs'},
    {value: '24 Hrs'},
  
  ];



  constructor(private fb: FormBuilder,
        private quotationService: QuotationService,
        private locationService : LocationService,
        private containerTypeService :ContainerTypeService,
        private authService: AuthService,
        private toastr: ToastrService,
        private dialogService: DialogService,
        private fileUploadService:FileUploadService,
        private itemService : ItemService,
        private route : ActivatedRoute,
        private router : Router, 
        private customerService : CustomerService,
        private companyProfileService: CompanyProfileService,
        private canvasImageService  : CanvasImageService,
        private themeService: NbThemeService,
        private decimalPipe: DecimalPipe )
      {
        this.datepickerConfig = Object.assign({},
          {   
            showWeekNumbers:false,
            dateInputFormat : 'YYYY-MM-DD'
          });
      }

  ngOnInit() {

   
      this.initInvoceType();
      this.initFormFields();
      this.getCompanyDetails();
      this.getAllLocations();
      this.getAllContainerType();

      this.getItemList();
      this.getControlPermissions();
  
      this.isBtnDisabled = true;
      this.isCancelBtnDisabled = true;
     
      this.getCustomerList();
      this.disableForm();
      this.viewQuotationById();
    

      this.autoCompleteCustomer();

      this.quotationForm.valueChanges.subscribe((data) => {
        this.logValidationErrors(this.quotationForm);
        });

        this.themeService.onThemeChange()
        .subscribe(themeName =>{
             this.isDark  = themeName.name ==='dark' ? true : false;
           });

  }// end oninit

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='QUO'
    });
    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }


  loadLogo(){
    
    if(this.companyData.length===1){
      if(this.companyData[0].Logo){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].Logo.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        this.logo = 'data:image/jpeg;base64,' + base64String;
       }else{
        this.logo =null;
       }
  
       if(this.companyData[0].DigitalSignature){
        let TYPED_ARRAY = new Uint8Array(this.companyData[0].DigitalSignature.data);
        const STRING_CHAR = TYPED_ARRAY.reduce((data,byte) =>{
          return data + String.fromCharCode(byte);
        },'');
        let base64String = btoa(STRING_CHAR);
        //this.signature = 'data:image/jpeg;base64,' + base64String;
       }else{
        //this.signature =null;
       }

    } 
  
   
  }

  getCompanyDetails(){

    this.companyProfileService.getCompanyDetails()
    .subscribe(
      (data) =>{

                this.companyData = data;
                this. loadLogo();            

                },
      (err) => {
        if(err instanceof HttpErrorResponse){                 
          if(err.status == 401){
            this.router.navigate(['/login']);
          }
        }
        console.log(err);
      }
    );
  
  }

  getAllLocations(){
    this.locationService.getAll()
     .subscribe(
        (data) => {
                  this.locationList = data;    
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });  

       
       
     }


     getAllContainerType(){
      this.containerTypeService.getAll()
       .subscribe(
          (data) => {
                    this.containerTypeList = data;    
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
  
         
         
       }

       fromLocationChangeEvent(event){
        if(event.target.selectedIndex===1){
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.width = "70%";
          this.dialogService.openDialog(LocationComponent,dialogConfig)
          .afterClosed().subscribe(res =>{
            this.getAllLocations();
          }); 
        }
       
      }
      
       toLocationChangeEvent(event){
         if(event.target.selectedIndex===1){
           const dialogConfig = new MatDialogConfig();
           dialogConfig.disableClose = true;
           dialogConfig.autoFocus = true;
           dialogConfig.width = "70%";
           this.dialogService.openDialog(LocationComponent,dialogConfig)
           .afterClosed().subscribe(res =>{
            this.getAllLocations();
           }); 
         }
        
       }
    
      
    
       containerTypeChangeEvent(event){
        if(event.target.selectedIndex===1){
          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.width = "70%";
          this.dialogService.openDialog(ContainerTypeComponent,dialogConfig)
          .afterClosed().subscribe(res =>{
           this.getAllContainerType();
          }); 
        }
       
      }


  
  autoComplete(index: number){
    this.filteredOptions[index] =this.getInvoiceItems.at(index).get('itemCode').valueChanges
    .pipe(
      startWith(''),
        map(value => this._filter(value))
    );

  }

  autoCompleteCustomer(){
      this.filteredCustomerList = this.quotationForm.get('cusName').valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  private _filter(itemCode: string): any[] {
    if(itemCode){
    const filterValue = itemCode.toLowerCase();
    return this.itemList.filter(option => option.ItemCode.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  
  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.CusName.toLowerCase().indexOf(filterValue) === 0);
    }
  }

  getItemData(i){
    var filteredData;
    var value  = this.getInvoiceItems.at(i).get('itemCode').value;
    if(value){
    filteredData = this.itemList.filter(itemList =>itemList.ItemCode.toLowerCase()===value.toLowerCase());
    if(filteredData.length ===1){
      this.getInvoiceItems.at(i).patchValue({ 
        description : filteredData[0].Description,
        unitCost : filteredData[0].UnitCost,
        unitPrice:  filteredData[0].UnitPrice,
        qty :'1.00', 
        amount : filteredData[0].UnitPrice,
      });   
    }else{
      this.getInvoiceItems.at(i).patchValue({ 
        description : '',
        unitCost : '',
        unitPrice:  '',
        qty: '',
        amount : '',
      });     

    }
  }
}




getCustomerDetails(){      
  var filteredData;
  var cusName = this.quotationForm.value.cusName;
  if(cusName){
  filteredData = this.customerList.filter(data =>data.CusName.toLowerCase()===cusName.toLowerCase());
   if(filteredData.length ===1){
     this.quotationForm.patchValue({
       cusId : filteredData[0].CusId,
       address :filteredData[0].Address,
     });
   }else{
    this.quotationForm.patchValue({
      address :null,
    });
   }
  }
}

  
getItemList(){
  this.itemService.getAll()
 .subscribe(
    (data) => {
              this.itemList = data                
              },
   (err) => 
            {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            });  
   
 }

  getCustomerList(){
  this.customerService.getAll()
   .subscribe(
      (data) => {
                this.customerList = data.filter((el)=>{
                  return el.Status !=="Deactivated";
                });             
                },
     (err) => 
              {
                if(err instanceof HttpErrorResponse){                 
                  if(err.status == 401){
                    this.router.navigate(['/login']);
                  }
                }
                console.log(err);
              });  
     
   }

 

       



  initInvoceType() : void{

    this.quotation = {
      quotationNo: '',
      quotationDate: '',
      dft:'',
      dc20:0.00,
      dc40: 0.00,
      cusId: '',
      cusName: '',
      address: '',
      containerType: '',
      fromLocation: '',
      toLocation:'',
      itemCode: '',
      description: '',
      unitPrice: 0.00,
      qty: 0.00,
      amount: 0.00,
      grandTotal: 0.00,
      remarks: '',
      status: '',
      createdBy : '',
    };
  }

  initFormFields() : void{
    this.quotationForm = this.fb.group({
      quotationNo : ['',Validators.required],
      quotationDate : ['',Validators.required],
      dft :[null],
      dc20 :[''],
      dc40 :[''],
      cusId :[''],
      cusName : [null,Validators.required],
      address : ['',Validators.required],
      remarks : [''],
      invoiceItems : this.fb.array([this.addInvoiceItem()]), 
       
    });

    this.autoComplete(0);
  }


  newButtonClick(): void {
    this.isfieldReadOnly  = false;
    this.isBtnDisabled = false;
    this.isShowAttachBtn=false;
    this.isHideBtn= false;
    this.isCancelBtnDisabled = true;
    this.quotationForm.reset();
    this.resetOtherControls();
    this.enableForm();
    this.getMaxId();
    this.addItemButtonClick();
    this.quotationForm.patchValue({
      quotationDate:  this.defaultDate
    });
     
   }

   getMaxId(){
    var quotationNo = 0;
    var quoNoPrefixZero  : String;
  
    this.quotationService.getMaxId()
    .subscribe(
      (res) => {
        quotationNo = Number(res[0].QuotationNo) + 1;
        quoNoPrefixZero = quotationNo.toString().padStart(6,'0');       
          this.quotationForm.patchValue({
            quotationNo : "QT" +quoNoPrefixZero
          });
         
      },        
      (err) =>  {
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
          }, 
      )

   }
  
   addInvoiceItem() : FormGroup{
     
    return this.fb.group({
      itemCode : ['',Validators.required],
      description : ['',Validators.required],   
      fromLocation : [null,Validators.required],
      toLocation : [null,Validators.required],
      containerType : [null,Validators.required],
      unitPrice :['',Validators.required],
      qty : ['',Validators.required],
      amount : ['',Validators.required],

     });
    
   }



   get getInvoiceItems(){
      return this.quotationForm.get('invoiceItems') as FormArray;
   }

   addItemButtonClick() : void {
      this.getInvoiceItems.push(this.addInvoiceItem());
      this.autoComplete(this.getInvoiceItems.length-1);
      this.updateBillTotal();   
  }

    removeItemButtonClick(itemIndex : number) : void{
      this.getInvoiceItems.removeAt(itemIndex);
      this.filteredOptions.splice(itemIndex, 1);
      this.updateBillTotal()
    }

    resetOtherControls() : void{
        while (this.getInvoiceItems.length !== 0) {
          this.getInvoiceItems.removeAt(0);
        }

        this.quotation.grandTotal = 0.00;
        this.quotation.status = '';

    }

    isNumeric(value){
      if(!isNaN(value) &&  !isNaN(parseFloat(value))){
        return true;
      } 
       return false;
    
    }
  
    calEachItemAmount(i){
      var unitPrice : number;
      var qty : number;
      var amount : number=0;
      
      var itemCode  = this.getInvoiceItems.at(i).get('itemCode').value
      if(itemCode){

      unitPrice = this.isNumeric(this.getInvoiceItems.at(i).get('unitPrice').value) ? parseFloat(this.getInvoiceItems.at(i).get('unitPrice').value) :null;
      qty = this.isNumeric(this.getInvoiceItems.at(i).get('qty').value) ?  parseFloat(this.getInvoiceItems.at(i).get('qty').value) : null;
      amount = (this.isNumeric(unitPrice) && this.isNumeric(qty)) ? parseFloat((unitPrice * qty).toFixed(2)) : null;

      this.getInvoiceItems.at(i).patchValue({unitPrice : unitPrice});
      this.getInvoiceItems.at(i).patchValue({qty : qty});
      this.getInvoiceItems.at(i).patchValue({amount : amount});


      }
  
      this.updateBillTotal();
    }


  updateBillTotal(){
    this.quotation.grandTotal = this.getInvoiceItems.value.reduce((prev,curr)=>prev + +curr.amount, 0);
   
  }


  mapFormValuesToModel(){
    this.quotationData =[];
    var result = [];

    for(let i=0; i < this.getInvoiceItems.length; i++){

    this.quotation.quotationNo=this.quotationForm.value.quotationNo;
    this.quotation.quotationDate=this.quotationForm.value.quotationDate;
    this.quotation.dft=this.quotationForm.value.dft;
    this.quotation.dc20=this.quotationForm.value.dc20;
    this.quotation.dc40=this.quotationForm.value.dc40;
    this.quotation.cusName=this.quotationForm.value.cusName;
    this.quotation.address = this.quotationForm.value.address;
    this.quotation.itemCode =this.getInvoiceItems.value[i].itemCode
    this.quotation.description=this.getInvoiceItems.value[i].description;  
    this.quotation.fromLocation =this.getInvoiceItems.value[i].fromLocation;
    this.quotation.toLocation = this.getInvoiceItems.value[i].toLocation;
    this.quotation.containerType = this.getInvoiceItems.value[i].containerType;
    this.quotation.unitPrice=this.getInvoiceItems.value[i].unitPrice;
    this.quotation.qty=this.getInvoiceItems.value[i].qty;
    this.quotation.amount=this.getInvoiceItems.value[i].amount;
    this.quotation.grandTotal=this.quotation.grandTotal;
    this.quotation.remarks = this.quotationForm.value.remarks;
    this.quotation.status = '';
    this.quotation.createdBy =this.authService.getUserLoggedIn();
    
    this.quotationData.push(
      this.quotation.quotationNo,
      this.quotation.quotationDate,
      this.quotation.dft,
      this.quotation.dc20,
      this.quotation.dc40,
      this.quotation.cusName,
      this.quotation.address,
     
          
      this.quotation.itemCode,
      this.quotation.description,
      this.quotation.fromLocation,
      this.quotation.toLocation,
      this.quotation.containerType,
      this.quotation.unitPrice,
      this.quotation.qty,
      this.quotation.amount,

      this.quotation.grandTotal,
      this.quotation.remarks,
      this.quotation.status,
      this.quotation.createdBy, //16

      );

    }

    while(this.quotationData.length){
      result.push(this.quotationData.splice(0,19));
    }

    return result;

  }

   
  saveButtonClick(): void {
    this.logValidationErrors(this.quotationForm,true);
    var data = this.mapFormValuesToModel();

    if(this.isFilledFromFields()){
        this.showProcessingIndicator = true;
          this.quotationService.addQuotation(data)
          .subscribe(
            (res) =>{

              if(res.success === 0){
                this.quotationForm.patchValue({
                quotationNo : res.autoId
                });
              this.saveButtonClick();
              this.showProcessingIndicator = false; 
              
              }else if(res.success === 1){
                console.log(res);
                this.toastr.success('Quotation created successfully','Success');
                this.isfieldReadOnly  = true;
                this.isBtnDisabled = true;
                this.isShowAttachBtn = true; 
                this.isHideBtn = true;
                this.isCancelBtnDisabled = false;
                this.disableForm(); 
                this.showProcessingIndicator = false; 
             }   
            
            },
            (err) =>{
              this.toastr.error('Failed to create quotation','Failure'); 
              this.showProcessingIndicator = false;   
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
          this.showProcessingIndicator = false;                                                                                                                                                                                                   
        } 
   }

   approvedButtonButtonClicked() : void{

    this.logValidationErrors(this.quotationForm,true);
    this.mapFormValuesToModel();
    var data = {
      quotationNo : this.quotation.quotationNo,
      cusId : this.quotation.cusId,
      status : 'Approved',
    };

    if(this.isFilledFromFields()){
    
          this.quotationService.updateQuotation(data)
          .subscribe(
            (res) =>{
              this.toastr.success('Quotation Approved','Success');
              this.isfieldReadOnly  = true;
              this.isBtnDisabled = true;
              this.isCancelBtnDisabled = false;
              this.disableForm();
                
            },
            (err) =>{
              this.toastr.error('Failed to approve quotation','Failure'); 
              if(err instanceof HttpErrorResponse){                 
                if(err.status == 401){
                  this.router.navigate(['/login']);
                }
              }
              console.log(err);
            
            }
          )
        } 

    else{
          this.toastr.warning('Required Fields cannot be empty or invalid.','Error Message');
                                                                                                                                                                                                        
        } 

      

   }

   deleteButtonClick(){   
    var quotationNo = this.quotationForm.get('quotationNo').value;
    if(quotationNo){
    this.dialogService.openConfirmDialog('Are you sure you want to delete this quotation?')
    .afterClosed().subscribe(res =>{
      if(res){
    const data = this.mapFormValuesToModel();  
     this.quotationService.deleteQuotation(quotationNo)
     .subscribe(
       (res) => {
                   this.toastr.success('Quotation deleted successfully','Success');
                   this.newButtonClick();
                   console.log(res);     
                 },        
       (err) =>  {
                   this.toastr.error('Failed to delete quotation','Failure');
                   if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 }, 
         )

     } 
   });
  }
}

   enableForm():void{
    Object.keys(this.quotationForm.controls).forEach(key => {
      this.quotationForm.controls[key].enable();
      //console.log("Enable "+key)     
    });

  }


  disableForm():void{
    Object.keys(this.quotationForm.controls).forEach(key => {
      this.quotationForm.controls[key].disable();
     // console.log("disable "+key);
    });

  }
  
  logValidationErrors(group: FormGroup = this.quotationForm,isDirty :boolean=false): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if(isDirty)
      {
        this.enableForm();
        this.quotationForm.controls[key].markAsTouched();
      }
        if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } 
    });
  }

  isFilledFromFields() : boolean {
    (<FormArray>this.quotationForm.get('invoiceItems')).controls.forEach((group: FormGroup) => {
      (<any>Object).values(group.controls).forEach((control: FormControl) => { 
          control.markAsTouched();
      }) 
    });

    var value = this.quotationForm.value.cusId;
    if(!value){
      this.quotationForm.patchValue({ cusId :  null,cusName :  null, address : null });    
    }

    for (var key in this.formErrors) {
      if (this.formErrors[key] !== null && this.formErrors[key] != "" && this.formErrors[key] != '')
          return false;
        }

        if(this.getInvoiceItems.length==0 || this.quotationForm.get('invoiceItems').invalid){
          return false;
          }
        return true;
  }

 



    viewQuotationById(){
        var hasQuotationNo;
        var quotationNo;

        hasQuotationNo =this.route.snapshot.queryParamMap.has('quotationNo');
         
          if(hasQuotationNo){
            quotationNo = this.route.snapshot.queryParamMap.get('quotationNo')
            this.quotationService.getQuotation(quotationNo)
            .subscribe(
              (data) => {
                        if(data){                 
                          this.isCancelBtnDisabled = false;
                          this.patchValuesToForm(data); 
                          this.isBtnDisabled = true;
                          this.isShowAttachBtn = true;
                          this.disableForm(); 
                          this.isfieldReadOnly = true;    
                          this.isHideBtn= true;                                      
                         }
                        },
            (err) => 
                      {
                        if(err instanceof HttpErrorResponse){                 
                          if(err.status == 401){
                            this.router.navigate(['/login']);
                          }
                        }
                        console.log(err);
                      });
      }else{
        this.newButtonClick();
      }

    }

patchValuesToForm(data){
  this.quotationForm.patchValue({  
    quotationNo : data[0].QuotationNo,
    quotationDate : moment(data[0].QuotationDate).format("YYYY-MM-DD"),
    dft : data[0].DFT,
    dc20 : data[0].DC20,
    dc40 : data[0].DC40,
    cusId : data[0].CusId,
    cusName : data[0].CusName,
    address : data[0].Address,
    remarks : data[0].Remarks,

  });
  
  this.quotationForm.setControl('invoiceItems',this.setInvoiceItems(data));
  this.quotation.status= data[0].Status;
  this.quotation.grandTotal = data[0].GrandTotal;
  if(data[0].Status==='Approved'){
    this.isCreateInvoiceBtnDisabled = false;
  }

}


  setInvoiceItems(data) : FormArray{
    const invoiceItemArray = new FormArray([]);
    for(let i =0; i < data.length;i++){ 
      invoiceItemArray.push(this.fb.group({
        itemCode : [data[i].ItemCode],
        description : [data[i].Description],     
        fromLocation : [data[i].FromLocation],
        toLocation : [data[i].ToLocation],
        containerType : [data[i].ContainerType],
        unitPrice : [data[i].UnitPrice],
        qty : [data[i].Qty],
        amount : [data[i].Amount],    
      }));
    }
    return invoiceItemArray;
  }

  attachFileButtonClick(){
    this.fileUploadService.refNo = this.quotationForm.value.quotationNo;
     const dialogConfig = new MatDialogConfig();
     dialogConfig.disableClose = true;
     dialogConfig.autoFocus = true;
     dialogConfig.width = "75%";
     this.dialogService.openDialog(FileUploadComponent,dialogConfig);
        
    }


 

     createInvoiceButtonClicked(){  
      let quotationNo = this.quotationForm.value.quotationNo;
      this.router.navigate(['../invoice'],{queryParams : {'quotationNo':quotationNo},relativeTo : this.route});            
    }


    savePDF(action){
     
   
      const documentDefinition = { 
         pageSize: 'A4',
         pageOrientation: 'portrait',  
         pageMargins: [40, 40, 40, 60],
    
         content: [ 
             
           {
             columns :  [ 
             
               { image:this.logo,            
                 width: 130,
                 height: 70,
               },
               
               [
                 {
                   text: this.companyData[0].CompanyName,  
                   margin: [20, 0, 0, 0],
                   bold: true,
                   fontSize: 14,
                   width : '*'
                 },
                 {
                 columns: [
                     [
                       { text: this.companyData[0].Address,  width : '*',  margin: [20, 0, 0, 0]},  
                       { text: `Tel: ${this.companyData[0].Phone}`, width : '*',  margin: [20, 0, 0, 0]},  
                       { text: `Email: ${this.companyData[0].Email}`,  width : '*',  margin: [20, 0, 0, 0] },
                       { text: `Web: ${this.companyData[0].Web}`,  width : '*', margin: [20, 0, 0, 0] }  
                     ],
                     [ 
                       `\n\n`,
                       { text: `Quoation No   : ${this.quotationForm.value.quotationNo}`,  margin: [20, 0, 0, 0]},
                       { text: `Quoation Date :${moment(this.quotationForm.value.quotationDate).format("YYYY-MM-DD")}` ,  margin: [20, 0, 0, 0]},
   
                     ]
                   ]
                }
               ]
                   
             ]
           },  
   
           `\n`,
           {  
             table: {    
                 widths: ['*'],  
                 body: [  
                   [
                     { text:'QUOTATION',alignment:'center', border: [false, true, false, true], margin: [0, 0, 0, 0], width: 'auto',bold: true, fontSize: 22},
                   ],         
                 ],           
           },      
         },
           
     
           {
             columns : [
            
               [
                 
                 { text: 'Customer Details :', margin: [0, 20, 0, 5],  fontSize: 12,},  
                 { text: this.quotationForm.value.cusName,margin: [0, 0, 0, 0], bold:true,   fontSize: 12, },  
                 { text: this.quotationForm.value.address,margin: [0, 0, 0, 0] },  
   
               ],
               [                
                { text: `Detention Free Time        : ${this.quotationForm.value.dft}`,margin: [10, 20, 0, 0] },  
                { text: `Detention Charges 1x20 : ${this.quotationForm.value.dc20}`,margin: [10, 0, 0, 0] },  
                { text: `Detention Charges 1x40 : ${this.quotationForm.value.dc40}`,margin: [10, 0, 0, 0] },  
  
              ],
   
             ]
   
           },
   
           '\n\n',
          
                              
           {  
             layout: {
               defaultBorder: false,
               hLineWidth: function(i, node) {
                 return 1;
               },
               vLineWidth: function(i, node) {
                 return 1;
               },
               hLineColor: function(i, node) {
                 if (i === 1 || i === 0) {
                   return '#bfdde8';
                 }
                 return '#eaeaea';
               },
               vLineColor: function(i, node) {
                 return '#eaeaea';
               },
               hLineStyle: function(i, node) {
                 // if (i === 0 || i === node.table.body.length) {
                 return null;
                 //}
               },
               // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
               paddingLeft: function(i, node) {
                 return 10;
               },
               paddingRight: function(i, node) {
                 return 10;
               },
               paddingTop: function(i, node) {
                 return 2;
               },
               paddingBottom: function(i, node) {
                 return 2;
               },
               fillColor: function(rowIndex, node, columnIndex) {
                 return '#fff';
               },
             },
             table: {  
                
                 headerRows: 1,  
                 widths: ['*', 'auto','auto', 'auto','auto','auto', 'auto'],  
                 body: [  
                   [
                    { text: 'Description', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                    { text: 'From', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                    { text: 'To', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                    { text: 'ContainerType', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                    { text: 'UnitPrice', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                    { text: 'Qty', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]},
                    { text: 'Amount', style:'tableFont',fillColor: '#eaf2f5', border: [false, true, false, true],   margin: [0, 5, 0, 5]}],
                   ...this.getInvoiceItems.value.map(p => ([
                     { text :p.description, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},
                     { text :p.fromLocation, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},
                     { text :p.toLocation, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},
                     { text :p.containerType, border: [false, false, false, true],  margin: [0, 5, 0, 5],style:'tableFont'},
                     {text : this.transformNumberFormat(p.unitPrice), border: [false, false, false, true], margin: [0, 5, 0, 5], alignment: 'right',style:'tableFont' },
                     { text : this.transformNumberFormat(p.qty), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont'  }, 
                     { text: this.transformNumberFormat(p.amount), border: [false, false, false, true],margin: [0, 5, 0, 5],alignment: 'right',style:'tableFont' }])),               
                 ]           
           }       
         },
   
         '\n',
         {
          type: 'square',
          ul: [
            {text: 'This rate is valid for 30 days from the date of Quotation.', fontSize: 10, alignment: 'left', margin: [0, 5, 0, 0]},
            {text: 'Rates will be revised based on fuel increase or any other statutory charges increase for any authority.',fontSize: 10, alignment: 'left', margin: [0, 5, 0, 0]},
            {text: 'Please send your written confirmation in order to precede the operation.',fontSize: 10, alignment: 'left', margin: [0, 5, 0, 0]},
          ]
        },
       


         {
           columns : [
                 [   
                   '\n',
                   '\n\n',     
                   {alignment:'right',canvas: [{ margin: [0, 50, 0, 5], type: 'line', x1: 0, y1: 5, x2: 200, y2: 5, lineWidth: 1,lineColor: '#808080',dash: { length: 2 }, }]},
                   {text: 'Maritime Freight System (Pvt) Ltd', alignment: 'right', margin: [0, 5, 0, 5]},
                 ],                          
           
           ]
   
         },
   
         '\n','\n',
   
   
     ],  // end content
   
     footer: ()=> {
   
       return [
       
         { margin: [40, 5, 40, 10],canvas: [{type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 1 } ]},
     
       ]
       
        },
   
     
     
   
    
         styles: {  
           reportHeader: {  
               bold: true,  
               decoration: 'underline',  
               fontSize: 14,  
               margin: [0, 15, 0, 15],
               alignment: 'center',             
           },
           tableFont: {  
             fontSize: 10,  
              
         
           }       
       } 
         
         
        };// end 
   
   
         if(action==='open'){    
               pdfMake.createPdf(documentDefinition).open();  
             
           }else if(action === 'print'){    
               pdfMake.createPdf(documentDefinition).print();          
           }
           else if(action === 'download'){    
             pdfMake.createPdf(documentDefinition).download(`Quotation-${this.quotationForm.value.quotationNo}`);     
         }
   
   
      }
   
  
  
     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }


  

}
